// extracted by mini-css-extract-plugin
export default {"customTabs":"custom-tabs_customTabs__3Yd+H"};